// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textoarriba{vertical-align:top}.tablaDiag{border:1px solid #ececec;border-collapse:collapse}.gradiente{background-image:repeating-linear-gradient(45deg,rgba(245,127,23,.2),rgba(245,127,23,.2) 2px,#fff 0,#fff 10px)}.colorNa-mat{color:\"blue\"}.colorNa-ves{color:\"green\"}.colorNa-noc{color:\"red\"}", ""]);
// Exports
module.exports = exports;
